import EditIcon from "@mui/icons-material/Edit";
import { Checkbox, Switch, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import ClipBoardCheck from "../../../../assets/icons/ClipBoardCheckIco";
import MailIco from "../../../../assets/icons/MailIco";
import NotificationIco from "../../../../assets/icons/NotificationIco";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import SnackBar from "../../../../component/SnackBar";
import { CustomDiv } from "../../../../modules/chat-bot/style";
import { CommonGrid2 } from "../../../../modules/common-components/StyledComponents";
import { HandleSkeletion } from "../../../../utils/constants";
import {
  NotificationCall,
  NotificationPutCall,
} from "../../../../redux/action/OrganizationSetup";

export default function Notifications() {
  const storageData = JSON.parse(localStorage.getItem("credential"));
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [notifications, setNotifications] = useState({
    emailData: [
      {
        email: "",
        expand: "See Less",
        settings: {
          creation: true,
          activation: true,
          rescore: true,
          coversheet: true,
          coversheet_confirmation: true,
          interview: true,
          interest_email: true,
          job_score: true,
          submission: true,
        },
      },
    ],
    cc_primary_user: true,
    user_type_for_coversheet: "",
    user_type_for_interest_email: "",
    user_type_for_interview: "",
    user_type_for_reference: "",
    loading: false,
  });
  const preference = [
    {
      name: "CC Primary on all Notifications",
      description:
        "Send all Communications to primary email  along with requestor",
      icon: <NotificationIco size="35px" />,
      title_name: "cc_primary_user",
    },
    {
      name: "Send Candidate Coversheet request directly",
      description:
        "Send coversheet request to candidate directly if email is available. If no, request email will go to primary email",
      icon: <ClipBoardCheck size="35px" strokeWidth="1" />,
      title_name: "user_type_for_coversheet",
    },
    {
      name: "Send Candidate interest emails directly",
      description:
        "Send interest email to candidate directly if email is available. If no, request email will go to primary email",
      icon: <MailIco size="35px" />,
      title_name: "user_type_for_interest_email",
    },
    {
      name: "Schedule Interview directly with candidate",
      description:
        "Will schedule interview with requestors calendar info with candidate.",
      icon: <MailIco />,
      title_name: "user_type_for_interview",
    },
    {
      name: "Send Reference link directly",
      description:
        "The reference form link will be shared with the respective references.",
      icon: <MailIco />,
      title_name: "user_type_for_reference",
    },
  ];
  const emailData = [
    {
      email: "",
      details: [
        {
          name: "New job, Candidate & SOW is created",
          check: false,
          title_name: "creation",
        },
        {
          name: "New job, Candidate & SOW is activated",
          check: false,
          title_name: "activation",
        },
        {
          name: "Rescore is completed",
          check: false,
          title_name: "rescore",
        },
        {
          name: "Scoring error occurs",
          check: true,
          title_name: "job_score",
        },
        {
          name: "Share Coversheet",
          check: false,
          title_name: "coversheet",
        },
        {
          name: "Candidates submits their coversheet",
          check: false,
          title_name: "coversheet_confirmation",
        },
        {
          name: "Interest Email",
          check: false,
          title_name: "interest_email",
        },
        {
          name: "Submission Document",
          check: false,
          title_name: "submission",
        },
      ],
    },
  ];
  const [button, setButton] = useState({
    condition: true,
    disabled: false,
    saveLoading: false,
    cancelLoading: false,
  });

  const [mobileData, setMobileData] = useState([
    {
      email: "",
      expand: "See Less",
      details: [
        {
          name: "New job, Candidate & SOW is created",
          check: false,
        },
        {
          name: "Rescore is completed",
          check: false,
        },
        {
          name: "Scoring error occurs",
          check: true,
        },
        {
          name: "Candidates submits their coversheet.",
          check: false,
        },
      ],
    },
  ]);

  const handleSeeDetails = (setFieldValue, index, values) => {
    setFieldValue(
      `emailData[${index}].expand`,
      values.emailData[index].expand === "See Less" ? "See More" : "See Less"
    );
  };

  const handleMobileSeeDetails = (index) => {
    setMobileData((prev) =>
      prev.map((_, i) =>
        index === i
          ? {
              ..._,
              expand: _.expand === "See Less" ? "See More" : "See Less",
            }
          : _
      )
    );
  };

  const handleAddMobile = () => {
    const newItem = {
      email: "",
      expand: "See Less",
      details: [
        {
          name: "New job, Candidate & SOW is created",
          check: false,
        },
        {
          name: "Rescore is completed",
          check: false,
        },
        {
          name: "Scoring error occurs",
          check: true,
        },
        {
          name: "Candidates submits their coversheet.",
          check: false,
        },
      ],
    };
    setMobileData((prev) => [...prev, newItem]);
  };

  const handleDeleteMobile = (index) => {
    setMobileData((prev) => prev.filter((item, _) => index !== _));
  };
  const handleSubmit = async (values) => {
    setButton((prev) => ({
      ...prev,
      disabled: true,
      saveLoading: true,
    }));
    try {
      const { email, expand, ...restEmailData } = values.emailData[0];
      let payload = {
        ...restEmailData,
        email: values.emailData[0].email,
        cc_primary_user: values.cc_primary_user,
        user_type_for_coversheet: values.user_type_for_coversheet,
        user_type_for_interest_email: values.user_type_for_interest_email,
        user_type_for_interview: values.user_type_for_interview,
        user_type_for_reference: values.user_type_for_reference,
      };
      let data = await NotificationPutCall(payload);
      setSnackbarState({
        open: true,
        severity: "success",
        message: data.message,
      });
      setButton((prev) => ({
        ...prev,
        condition: true,
        disabled: false,
        saveLoading: false,
      }));
      handleNoficationCall();
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message || error.message,
      });
      setButton((prev) => ({
        ...prev,
        disabled: false,
        saveLoading: false,
      }));
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleEditDetails = () => {
    setButton((prev) => ({
      ...prev,
      condition: false,
    }));
  };

  const handleCancel = () => {
    setButton((prev) => ({
      ...prev,
      disabled: true,
      cancelLoading: true,
    }));
    setTimeout(() => {
      setButton((prev) => ({
        ...prev,
        disabled: false,
        cancelLoading: false,
        condition: true,
      }));
      handleNoficationCall();
    }, 1000);
  };

  const handleNoficationCall = async () => {
    setNotifications((prev) => ({
      ...prev,
      loading: true,
    }));

    try {
      const data = await NotificationCall();
      setNotifications((prev) => ({
        ...prev,
        emailData: [
          {
            expand: "See Less",
            email: data.email,
            settings: { ...data.settings },
          },
        ],
        cc_primary_user: data.cc_primary_user,
        user_type_for_coversheet: data.user_type_for_coversheet,
        user_type_for_interest_email: data.user_type_for_interest_email,
        user_type_for_interview: data.user_type_for_interview,
        user_type_for_reference: data.user_type_for_reference,
        loading: false,
      }));
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message || error.message,
      });
      setNotifications((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };
  useEffect(() => {
    handleNoficationCall();
  }, []);
  return (
    <CustomDiv padding="1.5rem">
      <Formik
        enableReinitialize
        initialValues={notifications}
        onSubmit={async (values, actions) => {
          handleSubmit(values);
        }}
      >
        {({ values, errors, validateForm, touched, setFieldValue }) => {
          return (
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
            >
              <CommonGrid2
                display={"flex"}
                gap={"10px"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Typography variant="body5">Email Notifications</Typography>
              </CommonGrid2>
              {emailData.map((item, index) => (
                <CommonGrid2
                  display={"flex"}
                  size={12}
                  gap={"1rem"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  border={"1px solid #EAECF0"}
                  borderRadius={"10px"}
                  padding={"1rem"}
                  flexWrap={"wrap"}
                  marginTop={"1rem"}
                >
                  {notifications.loading ? (
                    <HandleSkeletion
                      height={40}
                      transform="scale(1)"
                      width={"100%"}
                    />
                  ) : (
                    <Fragment>
                      <CommonGrid2
                        alignItems={"end"}
                        justifyContent={"space-between"}
                        container
                        spacing={2}
                        width={"100%"}
                      >
                        <CommonGrid2
                          item
                          size={{ xs: 12, lg: 8, md: 7, sm: 8 }}
                          display={"flex"}
                          flexDirection={"column"}
                          gap={"8px"}
                        >
                          <Typography
                            variant="p"
                            color="#344054"
                            fontSize="15px"
                          >
                            {`Email Address ${
                              index === 0 ? "" : index + 1
                            }`}
                          </Typography>
                          <CommonTextField
                            padding={"10px"}
                            placeholder={"Enter Email"}
                            value={values.emailData[index].email}
                            disabled
                          />
                        </CommonGrid2>
                        <CommonGrid2
                          item
                          size={{ xs: 12, lg: 4, md: 5, sm: 4 }}
                          display={"flex"}
                          justifyContent={"end"}
                        >
                          <CommonButton
                            value={values.emailData[index].expand}
                            variant="outlined"
                            color="#344054"
                            gap={"0px"}
                            padding={"5px 1rem"}
                            fontWeight={"600"}
                            fontSize={"15px"}
                            border={"#D0D5DD"}
                            onClick={() =>
                              handleSeeDetails(setFieldValue, index, values)
                            }
                          />
                        </CommonGrid2>
                      </CommonGrid2>

                      {values.emailData[index].expand === "See Less" && (
                        <CommonGrid2 width={"100%"}>
                          <Typography variant="body4" fontWeight={600}>
                            Notify me when ...
                          </Typography>
                          {item.details.map((item) => (
                            <CommonGrid2 display={"flex"} alignItems={"center"}>
                              <Checkbox
                                checked={
                                  values.emailData[index]["settings"][
                                    item.title_name
                                  ]
                                }
                                disabled={button.condition}
                                onChange={(e) =>
                                  setFieldValue(
                                    `emailData[${index}].settings.${item.title_name}`,
                                    e.target.checked
                                  )
                                }
                              />
                              <Typography variant="body4">
                                {item.name}
                              </Typography>
                            </CommonGrid2>
                          ))}
                        </CommonGrid2>
                      )}
                    </Fragment>
                  )}
                </CommonGrid2>
              ))}

              {/* <CommonGrid2
                display={"flex"}
                gap={"10px"}
                alignItems={"center"}
                justifyContent={"space-between"}
                marginTop={"1.5rem"}
              >
                <Typography variant="body5">Mobile Notifications</Typography>
                <CommonButton
                  value={"Add Number"}
                  startIcon={<AddIco />}
                  variant="outlined"
                  color="#344054"
                  gap={"0px"}
                  padding={"10px 1rem"}
                  fontWeight={"600"}
                  fontSize={"15px"}
                  border={"#D0D5DD"}
                  svg={true}
                  onClick={handleAddMobile}
                />
              </CommonGrid2>
              {mobileData.map((item, index) => (
                <CommonGrid2
                  display={"flex"}
                  size={12}
                  gap={"1rem"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  border={"1px solid #EAECF0"}
                  borderRadius={"10px"}
                  padding={"1rem"}
                  flexWrap={"wrap"}
                  marginTop={"1rem"}
                >
                  <CommonGrid2
                    alignItems={"end"}
                    justifyContent={"space-between"}
                    container
                    spacing={2}
                    width={"100%"}
                  >
                    <CommonGrid2
                      item
                      size={{ xs: 12, lg: 8, md: 7, sm: 12 }}
                      display={"flex"}
                      flexDirection={"column"}
                      gap={"8px"}
                    >
                      <Typography variant="p" color="#344054" fontSize="15px">
                        {`Mobile Number ${
                          index === 0 ? "(Primary)" : index + 1
                        }`}
                      </Typography>
                      <CommonTextField
                        padding={"10px"}
                        placeholder={"Enter Email"}
                      />
                    </CommonGrid2>
                    <CommonGrid2
                      item
                      size={{ xs: 12, lg: 4, md: 5, sm: 12 }}
                      display={"flex"}
                      justifyContent={"end"}
                      gap={"10px"}
                    >
                      <CommonButton
                        value={<DeleteIco stroke="red" />}
                        variant="outlined"
                        padding={"10px 12px"}
                        minWidth={"max-content"}
                        svg={true}
                        customStyle={{
                          maxHeight: "fit-content",
                        }}
                        onClick={() => handleDeleteMobile(index)}
                      />
                      <CommonButton
                        value={item.expand}
                        variant="outlined"
                        color="#344054"
                        gap={"0px"}
                        padding={"5px 1rem"}
                        fontWeight={"600"}
                        fontSize={"15px"}
                        border={"#D0D5DD"}
                        onClick={() => handleMobileSeeDetails(index)}
                      />
                    </CommonGrid2>
                  </CommonGrid2>

                  {item.expand === "See Less" && (
                    <CommonGrid2 width={"100%"}>
                      <Typography variant="body4" fontWeight={600}>
                        Notify me when ...
                      </Typography>
                      {item.details.map((item) => (
                        <CommonGrid2 display={"flex"} alignItems={"center"}>
                          <Checkbox checked={item.check} />
                          <Typography variant="body4">{item.name}</Typography>
                        </CommonGrid2>
                      ))}
                    </CommonGrid2>
                  )}
                </CommonGrid2>
              ))} */}

              {(storageData?.role === "Admin" ||
                storageData?.role === "Demo") && (
                <CommonGrid2 container spacing={1} size={12} marginTop={"1rem"}>
                  <Typography variant="body5" width={"100%"}>
                    Admin settings
                  </Typography>
                  {preference.map((item, index) => (
                    <CommonGrid2
                      size={12}
                      display={"flex"}
                      gap={"10px"}
                      alignItems={"center"}
                      border={"1px solid #EAECF0"}
                      borderRadius={"10px"}
                      padding={"1rem"}
                    >
                      {notifications.loading ? (
                        <HandleSkeletion
                          height={40}
                          transform="scale(1)"
                          width={"100%"}
                        />
                      ) : (
                        <Fragment>
                          <CommonGrid2
                            size={12}
                            display={"flex"}
                            gap={"1rem"}
                            alignItems={"center"}
                            justifyContent={"space-between"}
                            flexWrap={"wrap"}
                          >
                            <CommonGrid2
                              display={"flex"}
                              gap={"1rem"}
                              alignItems={"center"}
                            >
                              <CustomDiv>{item.icon}</CustomDiv>
                              <CommonGrid2
                                display={"flex"}
                                flexDirection={"column"}
                              >
                                <Typography variant="body3">
                                  {item.name}
                                </Typography>
                                <Typography
                                  variant="body3"
                                  color="#667085"
                                  fontWeight={500}
                                >
                                  {item.description}
                                </Typography>
                              </CommonGrid2>
                            </CommonGrid2>
                          </CommonGrid2>
                          <Switch
                            disabled={button.condition}
                            checked={
                              item.title_name === "cc_primary_user"
                                ? values[item.title_name]
                                : values[item.title_name] === "CANDIDATE"
                            }
                            sx={{
                              ...(button.condition &&
                              (item.title_name === "cc_primary_user"
                                ? !values[item.title_name]
                                : values[item.title_name] !== "CANDIDATE")
                                ? {
                                    "& .MuiSwitch-track": {
                                      border: "1px solid",
                                    },
                                  }
                                : {}),
                            }}
                            onChange={(e) =>
                              setFieldValue(
                                item.title_name,
                                item.title_name === "cc_primary_user"
                                  ? e.target.checked
                                  : e.target.checked
                                  ? "CANDIDATE"
                                  : "PRIMARY USER"
                              )
                            }
                          />
                        </Fragment>
                      )}
                    </CommonGrid2>
                  ))}
                </CommonGrid2>
              )}
              <CommonGrid2
                justifyContent={"end"}
                display={"flex"}
                gap={"1rem"}
                marginTop={"1rem"}
              >
                {button.condition ? (
                  <CommonButton
                    value={"Edit Details"}
                    startIcon={<EditIcon />}
                    fontWeight={600}
                    padding={"8px 1rem"}
                    gap="0px"
                    disabled={notifications.loading}
                    width="max-content"
                    onClick={handleEditDetails}
                  />
                ) : (
                  <Fragment>
                    <CommonButton
                      variant="outlined"
                      value={"Cancel"}
                      fontWeight={600}
                      padding={"8px 1rem"}
                      width="max-content"
                      onClick={handleCancel}
                      disabled={button.disabled}
                      loading={button.cancelLoading}
                    />
                    <CommonButton
                      value={"Save"}
                      fontWeight={600}
                      padding={"8px 1.5rem"}
                      width="max-content"
                      type="submit"
                      disabled={button.disabled}
                      loading={button.saveLoading}
                    />
                  </Fragment>
                )}
              </CommonGrid2>
            </Form>
          );
        }}
      </Formik>
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
